// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2XQS5","title":"AfterFrontImage_title__3m61P"};